export const HEADER_TEXT = 'Small Group Intervention Progress'
export const LESSONS_COMPLETED_SORT_TITLE_TEXT = 'Lessons Completed'
export const NEXT_BUTTON_TEXT = 'Next'
export const PREVIOUS_BUTTON_TEXT = 'Previous'
export const SCHOOLS_SORT_TITLE_TEXT = 'School'
export const SMALL_GROUPS_SORT_TITLE_TEXT = 'Small Groups Created'
export const TIER_2_LABEL_TEXT = 'TIER 2'
